import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup } from 'reactstrap'
import { connect } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import {
  hideContract,
  showContract,
  setUniqueContractVisible,
  removeContracts,
} from 'actions/contractSelection'

import {
  callValorisation
} from 'actions/contract'

import { isAdmin } from 'selectors/user'

const CurrentSelectionItem = (props) => {
  const { contract, visibleContracts, hideContract, showContract, valoriseContract } = props
  const { t } = useTranslation()
  const callValoriseContract = React.useCallback(() => {
    valoriseContract(t('sidebar.current.valoriseContract'))
  })

  const location = useLocation()
  const history = useHistory()

  const { CtrNrjId, id, FormattedName } = contract
  const isSelectionItemVisible = visibleContracts.includes(id)

  const isZoomOnContract = props.selectedContract && props.selectedContract.id === id

  const isOnExec = isZoomOnContract && location.pathname.startsWith('/exec')

  const isOnTransactions = isZoomOnContract && location.pathname.startsWith('/transactions')
  const isOnStratRW = isZoomOnContract && location.pathname.startsWith('/admin')

  return (
    <li
      className={
        'd-flex selected-contract' +
        (isSelectionItemVisible ? ' visible' : '') +
        (isZoomOnContract ? ' zoom' : '')
      }
    >
      {CtrNrjId === 2 && <i className="icon-elec" />}
      {CtrNrjId === 1 && <i className="icon-gaz" />}
      <span className="w-100" style={{ marginRight: 8, color: 'black' }}>
        {FormattedName}
      </span>
      <ButtonGroup className="ml-auto">
        {props.isAdmin && (
          <div className={'btn btn-secondary' + (isZoomOnContract ? ' zoom' : '')}>
            <i
              onClick={() => {
                props.setUniqueContractVisible(true)
                history.push(`/transactions/${contract.id}`)
              }}
              className={'icon-collapse-plus' + (isOnTransactions ? ' selected-activity' : '')}
            />
          </div>
        )}

        {props.isAdmin && (
          <div className={'btn btn-secondary' + (isZoomOnContract ? ' zoom' : '')}>
            <i
              onClick={() => {
                props.setUniqueContractVisible(false)
                history.push('/admin/')
              }}
              className={'icon-ico-menu-parameters' + (isOnStratRW ? ' selected-activity' : '')}
            />
          </div>
        )}

        <div className={'btn btn-secondary' + (isZoomOnContract ? ' zoom' : '')}>
          <i
            onClick={() => {
              if (isOnExec && isZoomOnContract) {
                props.removeUniqueContractVisible()
              } else {
                props.setUniqueContractVisible(true)
                history.push('/exec')
              }
            }}
            className={'icon-diag' + (isOnExec ? ' selected-activity' : '')}
          />
        </div>
        <div
          onClick={props.removeContract}
          className={'btn btn-secondary' + (isZoomOnContract ? ' zoom' : '')}
        >
          <i className="icon-cross" />
        </div>
        {props.isAdmin && (
          <div onClick={callValoriseContract} className="btn btn-secondary">
            <i className="icon-ico-brdcrmb-plain" />
          </div>
        )}

      </ButtonGroup>
    </li>
  )
}

const mapStateToProps = (state) => ({
  visibleContracts: state.contracts.visibleContracts,
  selectedContract: state.contracts.zoomOnContract,
  isAdmin: isAdmin(state),
})

const mapDispatchToProps = (dispatch, { contract }) => ({
  showContract: () => {
    dispatch(showContract(contract.id))
  },
  hideContract: () => {
    dispatch(hideContract(contract.id))
  },
  setUniqueContractVisible: (readonly) => {
    dispatch(setUniqueContractVisible(contract, readonly))
  },
  removeUniqueContractVisible: () => {
    dispatch(setUniqueContractVisible(null))
  },
  removeContract: () => {
    dispatch(removeContracts([contract.id]))
  },
  valoriseContract: (message) => {
    dispatch(callValorisation([contract.id], message))
  }
})

CurrentSelectionItem.propTypes = {
  contract: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentSelectionItem)
